import React from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '@wix/da-ds/pkg/formControls/lego/InputField';
import EditorUnlink from '@wix/da-ds/pkg/Icons/24x24/EditorUnlink';
import EditorLink from '@wix/da-ds/pkg/Icons/24x24/EditorLink';
import { useKeyDown } from '@wix/da-hooks/pkg/useKeyDown';
import cn from 'classnames';
import { cleanLinkSrc } from '../../../../utils/browser';
import EditorIconButton from '../../../_partials/EditorIconButton';
import s from './ViewLinkMenuContent.scss';
const ViewLinkMenuContent = ({ editor, onCancel, onRemove, onEdit, href })=>{
    const { t } = useTranslation('editor');
    // If the user presses escape, we should cancel
    useKeyDown({
        Escape: onCancel
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], 'ds-surface-tertiary')
    }, /*#__PURE__*/ React.createElement(TextInput, {
        id: "link",
        value: href,
        readOnly: true,
        inputClassname: s['link'],
        onClick: ()=>{
            if (href === null || href === void 0 ? void 0 : href.startsWith('#')) {
                return;
            }
            window.open(cleanLinkSrc(href), '_blank');
        }
    }), /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "node:linkRemove",
        icon: EditorUnlink,
        tooltipText: t('ext.linkMenu.popover.remove.tooltip'),
        "aria-label": t('ext.linkMenu.popover.remove.tooltip'),
        onClick: onRemove
    }), /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "node:linkEdit",
        icon: EditorLink,
        tooltipText: t('ext.linkMenu.popover.edit.tooltip'),
        "aria-label": t('ext.linkMenu.popover.edit.tooltip'),
        onClick: onEdit
    }));
};
ViewLinkMenuContent.displayName = 'ViewLinkMenuContent';
export default ViewLinkMenuContent;

//# sourceMappingURL=ViewLinkMenuContent.js.map